import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ILink } from '../../models/link';

@Component({
  selector: 'dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {
  @Input() links: ILink[] = [];
  @Input() selectedLink: ILink;

  @Output() onSelected: EventEmitter<ILink> = new EventEmitter();

  constructor() {}

  ngOnInit() {
    if (!this.selectedLink) {
      this.selectedLink = this.links[0];
    }
  }

  onChange(link: ILink) {
    this.onSelected.emit(link);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dropdown/dropdown.component.ts